import {Inject, Injectable} from '@angular/core';
import {IZIVIA_DEFAULT_ENVIRONMENT, IZIVIA_ENVIRONMENTS} from '../../tokens/environment.token';
import {IziviaMobileEnvironmentKey} from '../../domain/environment/iziviaMobileEnvironmentKey';
import {IziviaThemeEnvironment} from '../../domain/environment/iziviaMobileEnvironment';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    constructor(@Inject(IZIVIA_ENVIRONMENTS) private environments: IziviaThemeEnvironment[],
        @Inject(IZIVIA_DEFAULT_ENVIRONMENT) private defaultEnvironment: IziviaThemeEnvironment) {
    }

    public getAllEnvironments(): Array<IziviaThemeEnvironment> {
        return this.environments;
    }

    public getDefaultEnvironment(): IziviaThemeEnvironment {
        return this.defaultEnvironment;
    }

    public getEnvironmentFromKeyOrDefault(key: IziviaMobileEnvironmentKey): IziviaThemeEnvironment {
        return this.environments.find(environment => environment.key === key)
            || this.defaultEnvironment;
    }
}
